import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-labo',
  templateUrl: './labo.component.html',
  styleUrls: ['./labo.component.css']
})
export class LaboComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
